export default {"src":"/_next/static/media/faq-collapsed.80b205e7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};